import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalGeneric from "../../Common/ModalGeneric";
import OvertredelseskoderMiljogebyrCreateModalContent from "../OvertredelseskoderMiljogebyrForm";
import OpenModalComponent from "./OpenModalComponent";

import { postOvertredelseskoderMiljogebyr } from "../../../actions/overtredelseskoderMiljogebyrActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../utils/validationUtils";

const rules = {
  id: "required;isDigit;minValue=1",
  paragraf: "required;hasFormat=^.+ §.+$,1.3 §3-7",
  del: "required",
  belop: "required;isDigit",
  kortTekst: "required",
  langTekst: "required",
  arkivKode: "required",
  aktivertDato: "isDato;isLessThan=deaktivertDato",
  deaktivertDato: "isDato;isLargerThan=aktivertDato",
  overtredelseGruppeId: "required",
};

const initState = {
  open: false,
  submitButtonText: "Legg til ny",
  id: "",
  paragraf: "",
  del: "",
  belop: "",
  kortTekst: "",
  langTekst: "",
  arkivKode: "",
  aktivertDato: "",
  deaktivertDato: "",
  overtredelseGruppeId: 0,
  validationError: {},
  openDeaktiverConfirm: false,
};

export default function OvertredelseskoderMiljogebyr() {
  const dispatch = useDispatch();
  const overtredelsegrupper = useSelector((state) => state.overtredelsegrupper);

  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  const closeModal = () => setState(initState);
  const openModal = () => update({ open: true });

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePost = () => {
    update({ submitButtonText: "Legger til..." });
    dispatch(
      postOvertredelseskoderMiljogebyr({
        id: state.id && Number(state.id),
        paragraf: state.paragraf,
        del: state.del,
        belop: state.belop && Number(state.belop),
        kortTekst: state.kortTekst,
        langTekst: state.langTekst,
        arkivKode: state.arkivKode,
        overtredelseGruppeId: state.overtredelseGruppeId,
        aktivertDato: state.aktivertDato || null,
        deaktivertDato: state.deaktivertDato || null,
      }),
    )
      .then(() => closeModal())
      .catch(() => update({ submitButtonText: "Legg til ny" }));
  };

  const saveAndClose = () => {
    if (isValid() && !state.deaktivertDato) {
      handlePost();
    } else if (isValid() && state.deaktivertDato) {
      update({ open: false, openDeaktiverConfirm: true });
    }
  };

  const handleChange = (e) => {
    const draft = { ...state, [e.target.name]: e.target.value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <>
      <ModalGeneric
        modalTitle="Legg til ny overtredelseskode for miljøgebyr"
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={OpenModalComponent}
        submit={saveAndClose}
        submitButtonText="Legg til ny"
      >
        <OvertredelseskoderMiljogebyrCreateModalContent
          id={state.id}
          paragraf={state.paragraf}
          del={state.del}
          belop={state.belop}
          kortTekst={state.kortTekst}
          langTekst={state.langTekst}
          arkivkode={state.arkivKode}
          overtredelseGruppeId={state.overtredelseGruppeId}
          aktivertDato={state.aktivertDato}
          deaktivertDato={state.deaktivertDato}
          overtredelseGrupper={overtredelsegrupper}
          validationError={state.validationError}
          handleChange={handleChange}
        />
      </ModalGeneric>
      <ModalGeneric
        modalTitle="Deaktiver overtredelseskode"
        open={state.openDeaktiverConfirm}
        closeModal={() => update({ openDeaktiverConfirm: false, open: true })}
        submit={handlePost}
        submitButtonText={state.submitButtonText}
      >
        <p>Vil du deaktivere overtredelseskode {state.id}?</p>
      </ModalGeneric>
    </>
  );
}
